/*
  Lunveil — sélecteur de handpan au défilement.

  Un rail haut de N écrans, un panneau figé dedans. La position dans le rail
  décide de la carte affichée. Même mécanique sur téléphone et sur ordinateur :
  seule la mise en page de la carte change (CSS), pas le principe.

  Le calcul se fait dans un requestAnimationFrame avec un écouteur passif :
  le défilement n'est jamais bloqué, y compris sur mobile.

  Sans JavaScript ou en animations réduites, les cartes s'empilent
  verticalement — le contenu reste lisible et accessible.
*/
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var enEdition = window.Shopify && window.Shopify.designMode;
  var instances = [];

  function creer(section) {
    var rail = section.querySelector('.selecteur__rail');
    var cartes = Array.prototype.slice.call(section.querySelectorAll('[data-selecteur-carte]'));
    var puces = Array.prototype.slice.call(section.querySelectorAll('[data-selecteur-puce]'));
    var total = cartes.length;
    if (!rail || total === 0) return null;

    var actif = -1;
    var pulseTimer = null;
    var attente = false;

    function marquer(index) {
      if (index < 0 || index >= total || index === actif) return;
      actif = index;

      cartes.forEach(function (el, i) { el.classList.toggle('is-active', i === index); });
      puces.forEach(function (el, i) {
        el.classList.toggle('is-active', i === index);
        el.setAttribute('aria-current', i === index ? 'true' : 'false');
      });

      if (reducedMotion.matches) return;

      // relance l'onde sur la carte qui vient d'apparaître
      var carte = cartes[index];
      carte.classList.remove('is-pulsing');
      void carte.offsetWidth;
      carte.classList.add('is-pulsing');
      clearTimeout(pulseTimer);
      pulseTimer = setTimeout(function () {
        carte.classList.remove('is-pulsing');
      }, 1400);
    }

    /*
      L'en-tête du thème est collant : sans décalage, le haut du panneau passe
      derrière lui et le titre se retrouve coupé. On mesure sa hauteur réelle
      — en-tête plus bandeau d'annonce éventuel — et on la reporte en variable
      CSS. Le thème n'expose pas cette valeur au niveau global.
    */
    function mesurerOffset() {
      var haut = 0;
      var candidats = document.querySelectorAll('.section-header, .shopify-section-group-header-group');
      candidats.forEach(function (el) {
        var style = window.getComputedStyle(el);
        if (style.position !== 'sticky' && style.position !== 'fixed') return;
        var h = el.getBoundingClientRect().height;
        if (h > haut) haut = h;
      });
      section.style.setProperty('--selecteur-offset', Math.round(haut) + 'px');
      return haut;
    }

    function calculer() {
      attente = false;
      var offset = parseFloat(section.style.getPropertyValue('--selecteur-offset')) || 0;
      var box = rail.getBoundingClientRect();
      var visible = window.innerHeight - offset;
      var parcourable = box.height - visible;
      if (parcourable <= 0) return;
      var p = (offset - box.top) / parcourable;
      p = Math.min(Math.max(p, 0), 0.9999);
      marquer(Math.floor(p * total));
    }

    function planifier() {
      if (attente) return;
      attente = true;
      requestAnimationFrame(calculer);
    }

    function allerA(i) {
      var offset = mesurerOffset();
      var box = rail.getBoundingClientRect();
      var parcourable = box.height - (window.innerHeight - offset);
      if (parcourable <= 0) return;
      var haut = window.scrollY + box.top - offset;
      // on vise le milieu du segment pour éviter les bascules au bord
      window.scrollTo({ top: haut + parcourable * ((i + 0.5) / total), behavior: 'smooth' });
    }

    function replanifier() {
      mesurerOffset();
      planifier();
    }

    window.addEventListener('scroll', planifier, { passive: true });
    window.addEventListener('resize', replanifier, { passive: true });
    window.addEventListener('orientationchange', replanifier, { passive: true });
    window.addEventListener('load', replanifier);

    puces.forEach(function (puce, i) {
      puce.addEventListener('click', function () { allerA(i); });
    });

    section.classList.add('is-ready');
    cartes[0].classList.add('is-active');
    mesurerOffset();
    calculer();

    return { section: section, calculer: calculer, allerA: allerA, total: total };
  }

  function initSection(section) {
    if (section.dataset.lunveilInit === 'true') return;
    section.dataset.lunveilInit = 'true';
    var inst = creer(section);
    if (inst) instances.push(inst);
  }

  function init() {
    document.querySelectorAll('[data-lunveil-selecteur]').forEach(initSection);
  }

  function trouver(el) {
    for (var i = 0; i < instances.length; i++) {
      var s = instances[i].section;
      if (s === el || s.contains(el) || el.contains(s)) return instances[i];
    }
    return null;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* --- Éditeur de thème ---------------------------------------------------
     Shopify remplace le noeud à chaque réglage et fait défiler en haut du
     rail quand on sélectionne la section : sans traitement, on ne voit que
     le premier modèle et la mécanique paraît cassée. */

  document.addEventListener('shopify:section:load', function (e) {
    init();
    if (!enEdition || !e.target) return;
    var inst = trouver(e.target);
    if (inst) setTimeout(inst.calculer, 60);
  });

  document.addEventListener('shopify:section:select', function (e) {
    if (!enEdition || !e.target) return;
    var inst = trouver(e.target);
    if (inst) setTimeout(function () { inst.allerA(Math.floor(inst.total / 2)); }, 120);
  });

  document.addEventListener('shopify:block:select', function (e) {
    if (!enEdition || !e.target) return;
    var inst = trouver(e.target);
    if (!inst) return;
    var carte = e.target.closest ? e.target.closest('[data-selecteur-carte]') : null;
    var idx = carte ? parseInt(carte.getAttribute('data-selecteur-carte'), 10) : NaN;
    if (!isNaN(idx)) setTimeout(function () { inst.allerA(idx); }, 120);
  });
})();
